export default {
	params: [],
	validate: (value) => {
		return Stripe.card.validateCVC(value)
	},
	message: 'The provided CVC is invalid.'
};
